// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__25-vL","header":"MergedInvoice_header__1TKYr"};